import { gql } from '@apollo/client';
export const AbsenceTypeSourcesFragment = gql `
    fragment AbsenceTypeSourcesFragment on AbsenceTypeSources {
        primarySource
        fallbackSource
    }
`;
